import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';


@Component({
  selector: 'app-managers-agreements-contributions-dis-image-dialog',
  templateUrl: './managers-agreements-contributions-dis-image-dialog.component.html',
  styleUrls: ['./managers-agreements-contributions-dis-image-dialog.component.scss'],
})
export class ManagersAgreementsContributionsDisImageDialogComponent implements OnInit {

  scale = 1.6;
  readonly minScale = 1.6;
  readonly maxScale = 5;
  readonly scaleStep = 0.2;

  constructor(
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<ManagersAgreementsContributionsDisImageDialogComponent>,
  ) {
   
  }

  ngOnInit() {

  }

  closeDialog(): void {
    this.dialogRef.close();
  }


  zoomIn(): void {
    if (this.scale < this.maxScale) this.scale += this.scaleStep;
  }

  zoomOut(): void {
    if (this.scale > this.minScale) this.scale -= this.scaleStep;
  }

  resetZoom(): void {
    this.scale = 1.6;
  }

}
